<template>
    <div style="margin-top:-2.3%" class="px-2 border-top pt-2">
        <b-row>
            <b-col cols="3" class="border-right">
                <b-list-group>
                    <b-list-group-item :active="menuActive == 0" button @click="onChangeMenu(0)"
                        class="d-flex justify-content-between">
                        <span>กรุงเทพฯ</span>
                        <span><feather-icon icon="ChevronRightIcon" /></span>
                    </b-list-group-item>
                    <b-list-group-item v-if="isHaveCentral" :active="menuActive == 1" button @click="onChangeMenu(1)"
                        class="d-flex justify-content-between">
                        <span>มีศูนย์บริการ</span>
                        <span><feather-icon icon="ChevronRightIcon" /></span>
                    </b-list-group-item>
                    <b-list-group-item v-else :active="menuActive == 2" button @click="onChangeMenu(2)"
                        class="d-flex justify-content-between">
                        <span>ต่างจังหวัด (ไม่มีศูนย์บริการ)</span>
                        <span><feather-icon icon="ChevronRightIcon" /></span>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
            <b-col>
                <h3 class="mb-1 text-primary">{{ menuKey[menuActive] }}</h3>                
                <SlaSettingUI type="cm" alias="CM" :catList="catList" :catValue="catValue" @onSubmit="onSubmit" :catTimesAmount="catTimesAmount"/>
            </b-col>
        </b-row>
        
    </div>

</template>

<script>
import SlaSettingUI from "../slaSetting.vue"
import {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BButton,
    BFormCheckbox,
    BInputGroup,
    BFormInput,
    BFormTextarea,
    BFormRadioGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BListGroup,
    BListGroupItem,
    BCardText
} from "bootstrap-vue";
import { generateCatInit, catNameHolder } from "../../util"
import CatService from "@/services/setting/cat";


const MENU_HOLDER = { 0: "bangkok", 1: "haveCentral", 2: "notHaveCentral" }
const INIT_CAT = {
    "CAT1": null,
    "CAT2": null,
    "CAT3": null,
    "CAT4": null,
    "CAT5": null
}

export default {
    props: {
        isHaveCentral: {
            type: Number,
            default: true
        },
        isTriggerFetch:{
            type:Boolean,
            default:false
        }
    },
    components: {
        BRow,
        BCol,
        BCard,
        BFormGroup,
        BButton,
        BFormInput,
        BInputGroup,
        BFormCheckbox,
        BFormTextarea,
        BFormRadioGroup,
        BInputGroupPrepend,
        BInputGroupAppend,
        BListGroup,
        BListGroupItem,
        BCardText,
        SlaSettingUI,
        
    },
    data() {
        return {
            mode: "create",
            menuActive: 0,
            catIdHolder: {},
            menuKey: {
                0: "กรุงเทพฯ และเขตปริมณฑล",
                1: "มีศูนย์บริการ",
                2: "ต่างจังหวัด (ไม่มีศูนย์บริการ)"
            },
            haveCentralOptions: [
                { id: 1, text: "มี", value: true },
                { id: 2, text: "ไม่มี", value: false }
            ],
            catList: [],
            catValue: {
                "CAT1": null,
                "CAT2": null,
                "CAT3": null,
                "CAT4": null,
                "CAT5": null
            },
            catTimesAmount:{
                CAT1:0,
                CAT2:0,
                CAT3:0,
                CAT4:0,
                CAT5:0
            }
        }
    },
    computed: {
        paramSubCompanyId() {
            return this.$route.query.scid
        },
    },
    watch: {
        isHaveCentral: {
            immediate: true,
            handler(val) {
                this.menuActive = 0
                this.onFetchCat()
            }
        },
        isTriggerFetch: {
            immediate: true,
            handler(val) {
                const catSettingValue = this.$store.getters["sla/getCatSettingSelected"]
                this.onSubmit(catSettingValue)        
            }
        }
    },

    created() {
        this.catList = generateCatInit("cm", this.paramSubCompanyId);
        this.onFetchCat()
    },
    mounted() {
        this.$store.commit('sla/SET_CM_CENTRAL_TEXT', this.menuKey[this.menuActive])
        this.$store.commit('sla/SET_CM_TYPE_SELECTED', MENU_HOLDER[this.menuActive])
    },
    methods: {
        async onFetchCat() {
            this.catValue = { ...INIT_CAT }

            const result = await CatService.GetCatCmByCmType(this.paramSubCompanyId, MENU_HOLDER[this.menuActive])
            if (result.status == "success" && result?.data?.items?.length > 0) {
                this.mode = "edit"
                const cats = result.data?.items

                let catsHolder = {}
                for (let i = 0; i < cats.length; i++) {
                    const cat = cats[i];
                    catsHolder[cat.catCode] = cat.fixTime
                    this.catIdHolder[cat.catCode] = cat.id
                }

                this.catValue = { ...this.catValue, ...catsHolder }
                
            }

            if(result.data?.catTimesAmount){
                this.catTimesAmount = result.data?.catTimesAmount
            }
            
        },

        onChangeMenu(menu) {
            this.menuActive = menu

            this.$store.commit('sla/SET_CM_CENTRAL_TEXT', this.menuKey[menu])
            this.$store.commit('sla/SET_CM_TYPE_SELECTED', MENU_HOLDER[menu])
            this.onFetchCat()

        },
        async onSubmit(data) {
            const brandId = this.paramSubCompanyId
            let output = []       

            for (let i = 0; i < this.catList.length; i++) {
                const cat = this.catList[i];
                const catValue = data[cat.catCode]
                let catData = {
                    type: "cm",
                    brandId: brandId,
                    catCode: cat.catCode,
                    catName: catNameHolder(cat.catCode),
                    responseTime: "",
                    fixTime: catValue ? parseFloat(catValue) : "",
                    responseTimeOutZone: "",
                    fixTimeWithCentralOutZone: catValue ? parseFloat(catValue) : "",
                    fixTimeNoCentralOutZone: catValue ? parseFloat(catValue) : "",
                    isCentralZone: this.isCentral,
                    cmType: MENU_HOLDER[this.menuActive]
                }

                //Edit Mode
                if(this.mode == "edit"){                    
                    catData.id = this.catIdHolder[cat.catCode]
                }
                
                output.push(catData)
            }   

            if(output.length ==0){
                return
            }

            if (this.mode == "create") {
                await CatService.InsertCat(output)
                alert("บันทึกสําเร็จ")
            } else {
                await CatService.UpdateCat(output)
                alert("บันทึกสําเร็จ")
            }

            await this.onFetchCat()

        },

    }
}
</script>